// main.js
import { createApp } from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store/index'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn' //引入中文
import 'element-plus/dist/index.css'
import ImageUploadPlugin from './tools/image-upload' // 引入图片上传工具类

const app = createApp(App)
app.use(ImageUploadPlugin)// 全局挂载图片上传工具类
app.use(ElementPlus,{locale: zhCn})
app.use(store).use(router).mount('#app')